var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "candidate-change-status" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: { hide: _vm.closeModal },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _vm.candidate
            ? [
                _c(
                  "svg",
                  {
                    staticClass: "m-candidate-status-close",
                    attrs: {
                      width: "15",
                      height: "16",
                      viewBox: "0 0 15 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                    on: { click: _vm.closeModal },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                        fill: "#8E9CBB",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                        fill: "#8E9CBB",
                      },
                    }),
                  ]
                ),
                _c("div", { staticClass: "candidate-change-status__title" }, [
                  _vm._v("Изменить статус кандидата"),
                ]),
                _c(
                  "div",
                  { staticClass: "candidate-change-status__fullname" },
                  [_vm._v(" " + _vm._s(_vm.candidate.fullName.value) + " ")]
                ),
                _c("c-input", {
                  staticClass: "candidate-change-status__item status-select",
                  class: {
                    "m-change-status-select-choice-status-required":
                      _vm.form.candidateStatus === null &&
                      _vm.errorMessages.candidateStatus !== "",
                  },
                  attrs: {
                    label: "Статус",
                    type: "select",
                    items: _vm.candidateStatusesList,
                    searchable: true,
                    required: _vm.errorMessages.candidateStatus,
                    "required-condition": _vm.form.candidateStatus === null,
                    placeholder: "Выберите статус сотрудника",
                  },
                  model: {
                    value: _vm.form.candidateStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "candidateStatus", $$v)
                    },
                    expression: "form.candidateStatus",
                  },
                }),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isRejectedReason
                      ? _c("c-input", {
                          staticClass: "candidate-change-status__item",
                          class: {
                            "m-change-status-select-choice-status-required":
                              _vm.errorMessages.rejectionReason,
                          },
                          attrs: {
                            "floating-label": "Причина отказа",
                            type: "select",
                            items: _vm.rejectionReasons,
                            "with-special-value": true,
                            searchable: true,
                            clearable: true,
                            required: _vm.errorMessages.rejectionReason,
                            "required-condition":
                              _vm.errorMessages.rejectionReason,
                          },
                          model: {
                            value: _vm.form.rejectionReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "rejectionReason", $$v)
                            },
                            expression: "form.rejectionReason",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isAnotherRejectionReason
                      ? _c("c-input", {
                          staticClass: "candidate-change-status__item",
                          class: {
                            "m-change-status-select-choice-status-required":
                              _vm.errorMessages.anotherRejectionReason,
                          },
                          attrs: {
                            "floating-label": "Введите причину",
                            clearable: true,
                            "required-mark": true,
                            required: _vm.errorMessages.anotherRejectionReason,
                            "required-condition":
                              _vm.errorMessages.anotherRejectionReason,
                          },
                          model: {
                            value: _vm.form.anotherRejectionReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "anotherRejectionReason", $$v)
                            },
                            expression: "form.anotherRejectionReason",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.requiresDateTimeInput
                    ? _c(
                        "div",
                        {
                          staticClass: "candidate-change-status__item datetime",
                        },
                        [
                          _c("c-input", {
                            ref: "datepicker",
                            staticClass: "candidate-change-status__date",
                            class: {
                              "m-change-status-select-choice-status-required-datetime":
                                _vm.errorMessages.date,
                            },
                            attrs: {
                              label: "Дата",
                              editable: true,
                              type: "date",
                              format: "DD.MM.YYYY, dddd",
                              icon: "calendar",
                              placeholder: "00.00.0000",
                              required: _vm.errorMessages.date,
                              "required-mark": _vm.shouldDisplayRequiredMark,
                              "icon-right": true,
                            },
                            on: { invalidDate: _vm.sendErrorDateMessage },
                            model: {
                              value: _vm.form.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "date", $$v)
                              },
                              expression: "form.date",
                            },
                          }),
                          _c("c-input", {
                            staticClass: "candidate-change-status__time",
                            class: {
                              "m-change-status-select-choice-status-required-datetime":
                                _vm.errorMessages.time,
                            },
                            attrs: {
                              label: "Время",
                              type: "text",
                              mask: "##:##",
                              required: _vm.errorMessages.time,
                              "required-condition": _vm.errorMessages.time,
                              "required-mark": _vm.shouldDisplayRequiredMark,
                              placeholder: "00:00",
                            },
                            model: {
                              value: _vm.form.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "time", $$v)
                              },
                              expression: "form.time",
                            },
                          }),
                          _vm.isScheduledInterviewOrTestReason
                            ? _c("c-input", {
                                staticClass:
                                  "candidate-change-status__item place-select",
                                class: {
                                  "m-change-status-select-choice-status-required":
                                    _vm.form.filial === null &&
                                    _vm.errorMessages.filial,
                                },
                                attrs: {
                                  "floating-label": "Место проведения",
                                  type: "select",
                                  items: _vm.filialItems,
                                  searchable: true,
                                  clearable: true,
                                  "required-mark": true,
                                  required: _vm.errorMessages.filial,
                                  "required-condition":
                                    _vm.form.filial === null,
                                },
                                model: {
                                  value: _vm.form.filial,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "filial", $$v)
                                  },
                                  expression: "form.filial",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isScheduledInterviewOrTestReason
                      ? _c("c-input", {
                          staticClass: "candidate-change-status__item",
                          class: {
                            "m-change-status-select-choice-status-required":
                              _vm.form.accountable === null &&
                              _vm.errorMessages.accountable !== "",
                          },
                          attrs: {
                            "floating-label": "Ответственный",
                            type: "select",
                            "required-mark": true,
                            items: _vm.accountablePeopleAll,
                            searchable: true,
                            clearable: true,
                            required: _vm.errorMessages.accountable,
                            "required-condition": _vm.form.accountable === null,
                          },
                          model: {
                            value: _vm.form.accountable,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "accountable", $$v)
                            },
                            expression: "form.accountable",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isInternshipedReason
                      ? _c("c-input", {
                          staticClass: "candidate-change-status__item",
                          class: {
                            "m-change-status-select-choice-status-required":
                              _vm.form.filial === null &&
                              _vm.errorMessages.filial,
                          },
                          attrs: {
                            "floating-label": "Филиал",
                            type: "select",
                            "required-mark": true,
                            items: _vm.filialItems,
                            searchable: true,
                            clearable: true,
                            required: _vm.errorMessages.filial,
                            "required-condition": _vm.form.filial === null,
                          },
                          model: {
                            value: _vm.form.filial,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "filial", $$v)
                            },
                            expression: "form.filial",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.isInternshipedReason
                    ? _c(
                        "div",
                        { staticClass: "candidate-change-status__position" },
                        [
                          _c("c-input", {
                            staticClass:
                              "candidate-change-status__item position-select",
                            class: {
                              "m-change-status-select-choice-status-required":
                                _vm.errorMessages.position,
                            },
                            attrs: {
                              "floating-label": "Должность",
                              type: "select",
                              items: _vm.positionItems,
                              "required-mark": true,
                              required: _vm.errorMessages.position,
                              "required-condition": _vm.errorMessages.position,
                              searchable: true,
                              clearable: true,
                            },
                            model: {
                              value: _vm.form.position,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "position", $$v)
                              },
                              expression: "form.position",
                            },
                          }),
                          _vm.form.position && _vm.form.position.ranks.length
                            ? _c("c-input", {
                                staticClass:
                                  "candidate-change-status__item rank-select",
                                attrs: {
                                  "floating-label": "Разряд",
                                  type: "select",
                                  items: _vm.form.position
                                    ? _vm.form.position.ranks
                                    : [],
                                  searchable: true,
                                  clearable: true,
                                  "required-mark": true,
                                  required: _vm.errorMessages.rank,
                                  "required-condition": _vm.form.rank === null,
                                },
                                model: {
                                  value: _vm.form.rank,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "rank", $$v)
                                  },
                                  expression: "form.rank",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isInternshipedReason
                      ? _c("c-input", {
                          staticClass: "candidate-change-status__item",
                          class: {
                            "m-change-status-select-choice-status-required":
                              _vm.form.mentor === null &&
                              _vm.errorMessages.mentor !== "",
                          },
                          attrs: {
                            label: "Наставник",
                            placeholder: "Выберите сотрудника",
                            type: "select",
                            items: _vm.workers,
                            searchable: true,
                            clearable: true,
                            required: _vm.errorMessages.mentor,
                            "required-condition": _vm.form.mentor === null,
                          },
                          model: {
                            value: _vm.form.mentor,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mentor", $$v)
                            },
                            expression: "form.mentor",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isInternshipedReason
                      ? _c("c-switcher", {
                          staticClass: "candidate-change-status__item",
                          attrs: { label: "Создать пользователя сервиса" },
                          model: {
                            value: _vm.form.shouldCreateServiceUser,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shouldCreateServiceUser", $$v)
                            },
                            expression: "form.shouldCreateServiceUser",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _vm.isInternshipedReason && _vm.form.shouldCreateServiceUser
                      ? _c("c-input", {
                          staticClass: "candidate-change-status__item",
                          class: {
                            "m-change-status-select-choice-status-required":
                              !_vm.form.candidateEmail &&
                              _vm.errorMessages.candidateEmail !== "",
                          },
                          attrs: {
                            label: "Email",
                            placeholder: "user@example.ru",
                            clearable: true,
                            "required-mark": true,
                            required: _vm.errorMessages.candidateEmail,
                            "required-condition": !_vm.form.candidateEmail,
                          },
                          model: {
                            value: _vm.form.candidateEmail,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "candidateEmail", $$v)
                            },
                            expression: "form.candidateEmail",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("c-textarea", {
                  staticClass: "candidate-change-status__item comment",
                  attrs: {
                    "max-length": "500",
                    "floating-label": "Комментарий",
                  },
                  model: {
                    value: _vm.form.comment,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "comment", $$v)
                    },
                    expression: "form.comment",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "candidate-change-status__actions" },
                  [
                    _c("c-button", {
                      attrs: { color: "white", label: "Отменить" },
                      on: { click: _vm.closeModal },
                    }),
                    _c("c-button", {
                      attrs: {
                        color: "primary",
                        disabled: !_vm.form.candidateStatus,
                        label: "Сохранить",
                      },
                      on: { click: _vm.changeCandidateStatus },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }